import { ConversationFolder } from "@rms-types/modules/conversation-folder/entities/conversation-folder";
import { useSnackbar } from "notistack";

import { conversationFolderEndpoint } from "@/constants";
import { getErrorMessage } from "@/helpers";
import { UseDeleteOptions, useDelete } from "@/hooks";

export function useDeleteConversationFolder(options: UseDeleteOptions<ConversationFolder> = {}) {
  const endpoint = conversationFolderEndpoint.conversationFolder;
  const { enqueueSnackbar } = useSnackbar();

  const {
    mutate: deleteConversationFolder,
    error: deleteConversationFolderError,
    isPending: isDeleteConversationFolderPending,
    ...rest
  } = useDelete({
    endpoint,
    options: {
      ...options,
      onError: (error, variables, context) => {
        options.onError && options.onError(error, variables, context);
        enqueueSnackbar(getErrorMessage(error, "Failed to delete the folder"), { variant: "error" });
      },
    },
  });

  return {
    deleteConversationFolder,
    isDeleteConversationFolderPending,
    deleteConversationFolderError,
    ...rest,
  };
}
